export default "__VITE_ASSET__54ssZj6o__"